import React, { Component } from "react";
import ReactMarkdown from "react-markdown";
import PropTypes from "prop-types";
import icon from "../images/icone-info-step1.svg";
import gif_rosto from "../images/gif-posicione-rosto.gif";
import gif_oculos from "../images/gif-remove-oculos.gif";
import gif_selfie from "../images/gif-selfie.gif";
import Footer from "../components/Footer/Footer";
import CompanyLogo from "../components/CompanyLogo/CompanyLogo.";
import Header from "../components/Header";
export class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };
  }

  componentDidMount() {
    if (this.props.messageWarning) {
      this.setState({ step: 0 });
    }
  }

  handleClick() {
    this.props.onClick();
  }

  handleClickContinue() {
    this.props.continueVerification(true);
  }

  render() {
    return (
      <div className="container h-100">
        <div className="row px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            {!this.state.step && (
              <>
                <Header logo={this.props.logo} />
                <h2 className="card-title fw-bold text-white mt-2 text-center">ATENÇÃO</h2>
                <div className="row justify-content-center" style={{ display: "grid" }}>
                  <h6 className="card-text text-light mt-2 mb-1">
                    <ReactMarkdown>{this.props.messageWarning}</ReactMarkdown>
                  </h6>
                </div>
                <div className="row mt-5 justify-content-center">
                  <div className="col-8 d-grid">
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => (!this.props.existente ? this.setState({ step: 1 }) : this.handleClickContinue())}>
                      <b>PROSSEGUIR</b>
                    </button>
                  </div>
                </div>
              </>
            )}

            {this.state.step == 1 && (
              <>
                <img src={icon} style={{ maxHeight: "100px", height: "100%" }} alt="" className="img-fluid mx-auto d-block mt-4 mb-3" />
                <h1 className="card-title fw-bold text-white mt-2 text-center">PREPARE-SE PARA COMEÇAR</h1>
                <div className="row justify-content-center" style={{ display: "grid" }}>
                  <ul>
                    <li>
                      <h3 className="card-text text-light mt-2 mb-1">Inicie e conclua o processo sem fechar a tela.</h3>
                    </li>
                    <li>
                      <h3 className="card-text text-light mb-1">O processo é rápido e seguro.</h3>
                    </li>
                    {!this.props.authenticationNoDocument && (
                      <li>
                        <h3 className="card-text text-light">Pode ser que a gente precise da sua carteira de identidade (RG).</h3>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="row mt-5 justify-content-center">
                  <div className="col-8 d-grid">
                    <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClick()}>
                      INICIAR
                    </button>
                    <button type="button" className="btn btn-primary btn-sm mt-3" onClick={() => this.setState({ step: 2 })}>
                      <b>VER INSTRUÇÕES</b>
                    </button>
                  </div>
                </div>
                {this.props.infoBlocked && (
                  <div id="toast" className="toast bg-danger text-white fade show" style={{ top: "-16em", marginLeft: "auto", marginRight: "auto", position: "relative" }}>
                    <div className="toast-header bg-danger text-white">
                      <strong className="me-auto">
                        <h5>ATENÇÃO</h5>
                      </strong>
                      <button type="button" className="btn-close" aria-label="Close" onClick={() => (document.getElementById("toast").style.display = "none")}></button>
                    </div>
                    <div className="toast-body">
                      <h6 className="card-text text-light">Percebemos que você já interrompeu o processo mais de uma vez. Seu acesso poderá ser bloqueado. Esta é sua última tentativa.</h6>
                    </div>
                  </div>
                )}
              </>
            )}
            {this.state.step == 2 && (
              <>
                <h1 className="card-title fw-bold text-white mt-2 text-center">VEJA O EXEMPLO:</h1>
                {/* <span className="row justify-content-center">
                  <div  style={{width: '120px', height: '150px', borderRadius: '50%', backgroundColor: 'white', margin: '50px'}}></div>
                </span>                 */}
                <img src={gif_oculos} style={{ maxHeight: "270px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <div className="row justify-content-center" style={{ display: "grid" }}>
                  <ol>
                    <li>
                      <h3 className="card-text text-light mb-1">Tire óculos, boné ou qualquer coisa que cubra seu rosto.</h3>
                    </li>
                    <li>
                      <h3 className="card-text text-light">Vá para um local com boa iluminação.</h3>
                    </li>
                  </ol>
                </div>
                <div className="row mt-3 justify-content-center">
                  <div className="col-6 d-grid">
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.setState({ step: 1 })}>
                      <i className="fa fa-arrow-left"></i> ANTERIOR
                    </button>
                  </div>
                  <div className="col-6 d-grid">
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => this.setState({ step: 3 })}>
                      PRÓXIMO <i className="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
            {this.state.step == 3 && (
              <>
                <h1 className="card-title fw-bold text-white mt-2 text-center">VEJA O EXEMPLO:</h1>
                {/* <span className="row justify-content-center">
                  <div  style={{width: '120px', height: '150px', borderRadius: '50%', backgroundColor: 'white', margin: '50px'}}></div>
                </span> */}
                <img src={gif_rosto} style={{ maxHeight: "270px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <div className="row justify-content-center" style={{ display: "grid" }}>
                  <ol start="3">
                    <li>
                      <h3 className="card-text text-light mb-1">Coloque seu rosto neste espaço oval.</h3>
                    </li>
                    <li>
                      <h3 className="card-text text-light">Aproxime e fique parado até capturarmos a sua foto.</h3>
                    </li>
                  </ol>
                </div>
                <div className="row mt-3 justify-content-center">
                  <div className="col-6 d-grid">
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.setState({ step: 2 })}>
                      <i className="fa fa-arrow-left"></i> ANTERIOR
                    </button>
                  </div>
                  <div className="col-6 d-grid">
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => this.setState({ step: 4 })}>
                      PRÓXIMO <i className="fa fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
            {this.state.step == 4 && (
              <>
                <h1 className="card-title fw-bold text-white mt-2 text-center">VEJA O EXEMPLO:</h1>
                <img src={gif_selfie} style={{ maxHeight: "270px", borderRadius: "10px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold mt-5 text-center" style={{ color: "#a97f0c" }}>
                  IMPORTANTE:
                </h1>
                <h5 className="card-text text-light text-center">Levante o celular na altura dos seus olhos e de frente para o seu rosto.</h5>
                <div className="row mt-5 justify-content-center">
                  <div className="col-8 d-grid">
                    <button className="btn btn-primary fw-bold" type="button" onClick={() => this.handleClick()}>
                      OK, ESTOU PRONTO!
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Info.propTypes = {
  onClick: PropTypes.func.isRequired,
  infoBlocked: PropTypes.bool,
  existente: PropTypes.number,
  continueVerification: PropTypes.func,
  messageWarning: PropTypes.string,
  authenticationNoDocument: PropTypes.bool,
};

export default Info;
